/**
 * Matches every non-alphanumeric characters.
 */
const NonAlphaNumeric = /[^0-9a-z]/gi;

const NumericBaseCode = "0".charCodeAt(0);

/**
 * Maps a text to a collection of its alphanumeric numbers.
 * @param value - A text containing alphanumeric characters.
 */
const mapToAlphanumericNumbers = (value: string): Array<number> =>
  value
    .replace(NonAlphaNumeric, "")
    .toUpperCase()
    .split("")
    .map((character) => character.charCodeAt(0) - NumericBaseCode);

export default mapToAlphanumericNumbers;
